import { render, staticRenderFns } from "./ShareSelector.vue?vue&type=template&id=04c016f3&"
import script from "./ShareSelector.vue?vue&type=script&lang=js&"
export * from "./ShareSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports